import {
  useAccountStore,
  useCategoryStore,
  useGlobalUiStore,
  useTransactionStore,
} from '../../../common'
import type { Beat } from '../../../core'
import type { InsightsInstanceSlotData } from '../../../core/types/InsightsInstanceSlotData'
import { selectTransactionsByGuids } from '../../CommonUtils'

export const useTransactionHistory = (beat: Beat) => {
  const instanceSlotData = beat.insights_payload?.instance_slot_data as InsightsInstanceSlotData

  const transactionStore = useTransactionStore()
  const accountStore = useAccountStore()
  const categoryStore = useCategoryStore()
  const { displayedDateRange } = useGlobalUiStore()

  const beatTransactions = selectTransactionsByGuids(
    transactionStore.detailedTransactions,
    instanceSlotData?.transaction_guids,
  )

  const primaryTransaction = transactionStore.detailedTransactions.find(
    (transaction) => transaction.guid === instanceSlotData?.primary_transaction_guid,
  )

  const spendCategoryGuids = categoryStore.spendCategories.map((category) => category.guid)
  const allAccountGuids = accountStore.accounts.map((account) => account.guid)
  const categoryName = categoryStore.getCategoryName(instanceSlotData?.category_guid ?? '') || ''

  return {
    instanceSlotData,
    beatTransactions,
    primaryTransaction,
    spendCategoryGuids,
    allAccountGuids,
    categoryName,
    displayedDateRange,
    transactionStore,
  }
}
